import fetch from '@/utils/fetch'

export function login (phone, password) {
  const data = {
    phone,
    password
  }
  return fetch({
    url: '/loginAdmin',
    method: 'post',
    data
  })
}

export function logout () {
  return fetch({
    url: '/logoutAdmin',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js